@if (
  !state.verifyingTransfer && !state.error && !state.timeout && state.visible
) {
  @if (!state.error) {
    <div class="zp:bg-ZTN-50 zp:rounded-lg zp:border zp:border-ZTN-200">
      <p
        class="zp:text-center zp:text-ZTN-500 zp:font-medium zp:text-sm zp:py-4 zp:text-sm"
      >
        Please transfer the exact amount above, the <br />
        account is only valid for this particular transaction
      </p>
      <div
        class="zp:bg-white zp:m-1 zp:flex zp:flex-col zp:justify-center zp:items-center zp:pt-5 zp:pb-3 zp:px-3 zp:rounded-lg zp:border zp:border-ZTN-200"
      >
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="28" cy="28" r="28" fill="#F2F4F7" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.1005 31.9048L34.5397 31.9048L34.5397 33.4048L19.1005 33.4048L19.1005 31.9048Z"
            fill="#101828"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8497 33.4048C22.7947 33.4048 25.1952 30.8199 25.1952 28.0593V27.3093H23.6952V28.0593C23.6952 30.0236 21.9345 31.9048 19.8497 31.9048H19.0997V33.4048H19.8497Z"
            fill="#101828"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8497 31.9048C22.7947 31.9048 25.1952 34.4897 25.1952 37.2503V38.0003H23.6952V37.2503C23.6952 35.286 21.9345 33.4048 19.8497 33.4048H19.0997V31.9048H19.8497Z"
            fill="#101828"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.9003 22.5957L21.461 22.5957L21.461 24.0957L36.9003 24.0957L36.9003 22.5957Z"
            fill="#101828"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.1501 24.0957C33.2051 24.0957 30.8046 21.5108 30.8046 18.7502L30.8046 18.0002L32.3046 18.0002L32.3046 18.7502C32.3046 20.7145 34.0653 22.5957 36.1501 22.5957L36.9001 22.5957L36.9001 24.0957L36.1501 24.0957Z"
            fill="#101828"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.1501 22.5957C33.2051 22.5957 30.8046 25.1806 30.8046 27.9412L30.8046 28.6912L32.3046 28.6912L32.3046 27.9412C32.3046 25.9769 34.0653 24.0957 36.1501 24.0957L36.9001 24.0957L36.9001 22.5957L36.1501 22.5957Z"
            fill="#101828"
          />
        </svg>
        <p class="zp:py-2 zp:text-sm zp:font-medium zp:text-ZTN-500">
          {{ bankName }}
        </p>
        <div class="zp:flex zp:justify-center zp:items-center">
          <p
            id="acc-no"
            class="zp:text-xl zp:text-ZTN-900 zp:font-bold zp:tracking-[0.06em]"
          >
            {{ responseData ? responseData.accountNumber : "1122233334" }}
          </p>
          <p>
            @if (!copied) {
              <span
                role="button"
                (click)="copyToClipboard()"
                class="zp:ml-2 zp:flex zp:item-center zp:cursor-pointer"
              >
                <span class="zp:w-4 zp:h-4">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1576_42778)">
                      <path
                        d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                        stroke="#4F499F"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.33337 9.99998H2.66671C1.93033 9.99998 1.33337 9.40305 1.33337 8.66665V2.66665C1.33337 1.93027 1.93033 1.33331 2.66671 1.33331H8.66671C9.40311 1.33331 10 1.93027 10 2.66665V3.33331"
                        stroke="#4F499F"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1576_42778">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span class="zp:ml-1 zp:text-xs zp:font-medium zp:text-ZTP-800"
                  >Copy</span
                >
              </span>
            }
            @if (copied) {
              <span class="zp:ml-2 zp:text-xs zp:font-medium zp:text-ZTP-800">{{
                copyMessage
              }}</span>
            }
          </p>
        </div>
        <div class="zp:pt-1 zp:pb-4">
          <p class="zp:text-xs zp:font-semibold zp:text-ZTN-500">
            {{
              responseData
                ? responseData.accountName
                : "Stanbic Virtual Account"
            }}
          </p>
        </div>
        <div
          class="zp:bg-ZTN-50 zp:rounded-lg zp:text-center zp:w-full zp:border zp:border-ZTN-200"
        >
          <div class="zp:m-4">
            <p class="zp:font-bold zp:text-base zp:text-ZTN-900">
              <span class="zp:font-normal zp:text-sm zp:text-ZTN-400 zp:pr-1"
                >Confirming</span
              ><span class="loading-dots zp:text-lg"
                ><span>.</span><span>.</span><span>.</span></span
              >
            </p>
            <p class="zp:text-ZTN-500 zp:font-medium zp:text-sm zp:pt-2">
              {{
                accountNumberExpired ? "Account expired" : "Account expires in"
              }}
              <span></span>
              @if (!accountNumberExpired) {
                <span class="zp:text-ZTN-900 zp:font-bold zp:text-sm"
                  >{{ display }}
                </span>
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- <div class="error" *ngIf="state.error">
      <span class="error__icon">
        <svg width="18" height="21" viewBox="0 0 18 21" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 0H12V2H6V0ZM16.03 6.39L17.45 4.97C17.02 4.46 16.55 3.98 16.04 3.56L14.62 4.98C13.0273 3.69833 11.0443 2.99969 9 3C6.61305 3 4.32387 3.94821 2.63604 5.63604C0.948211 7.32387 0 9.61305 0 12C0 16.97 4.02 21 9 21C10.6943 21.0009 12.3544 20.5232 13.7891 19.622C15.2238 18.7207 16.3748 17.4325 17.1094 15.9057C17.8441 14.379 18.1325 12.6758 17.9415 10.9923C17.7506 9.30874 17.088 7.71341 16.03 6.39ZM10 13H8V7H10V13Z" />
        </svg>
      </span>
      <div class="error__header">
        <div class="error__message">Account number expired.</div>
      </div>
      <div class="resolution">
        <div>
          <div>
            <div class="resolution">
              <button class="omni-btn omni-btn-primary" (click)="tryAgain()">Try again</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
}

@if (state.timeout) {
  <div
    class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
  >
    <div
      class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
    >
      <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
        <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
      </div>
      <div
        class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
      >
        Transaction Status
      </div>
      <div class="zp:text-ZTN-500 zp:font-normal">
        <small class="zp:text-sm">
          {{ errorMessage }}
        </small>
      </div>
    </div>
  </div>
}

@if (state.invalidAmount && state.error) {
  <div
    class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
  >
    <div
      class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
    >
      <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="28" cy="28" r="27.5" fill="white" stroke="#FEE4E2" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.25 28C5.25 15.435 15.435 5.25 28 5.25C40.565 5.25 50.75 15.435 50.75 28C50.75 40.565 40.565 50.75 28 50.75C15.435 50.75 5.25 40.565 5.25 28ZM28 19.25C28.4641 19.25 28.9092 19.4344 29.2374 19.7626C29.5656 20.0908 29.75 20.5359 29.75 21V29.75C29.75 30.2141 29.5656 30.6592 29.2374 30.9874C28.9092 31.3156 28.4641 31.5 28 31.5C27.5359 31.5 27.0908 31.3156 26.7626 30.9874C26.4344 30.6592 26.25 30.2141 26.25 29.75V21C26.25 20.5359 26.4344 20.0908 26.7626 19.7626C27.0908 19.4344 27.5359 19.25 28 19.25ZM28 38.5C28.4641 38.5 28.9092 38.3156 29.2374 37.9874C29.5656 37.6592 29.75 37.2141 29.75 36.75C29.75 36.2859 29.5656 35.8408 29.2374 35.5126C28.9092 35.1844 28.4641 35 28 35C27.5359 35 27.0908 35.1844 26.7626 35.5126C26.4344 35.8408 26.25 36.2859 26.25 36.75C26.25 37.2141 26.4344 37.6592 26.7626 37.9874C27.0908 38.3156 27.5359 38.5 28 38.5Z"
            fill="#F04438"
          />
        </svg>
      </div>
      <div class="">
        <div
          class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
        >
          Payment Failed
        </div>
        <small class="zp:text-sm zp:text-ZTN-500 zp:font-normal">
          {{ errorMessage }}
        </small>
      </div>
    </div>
  </div>
}

@if (state.error && !state.invalidAmount) {
  <div
    class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
  >
    <div
      class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
    >
      <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
        <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
      </div>
      <div class="px-3">
        <div
          class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
        >
          We could not process this transaction
        </div>
        <div class="zp:text-sm zp:text-ZTN-500 zp:font-normal zp:leading-5">
          <small class="zp:text-sm">
            {{ errorMessage }}
          </small>
        </div>
      </div>
    </div>
  </div>
}

@if (state.verifyingTransfer) {
  <div class="zp:font-mont verification-loader">
    <span class="omni-spinner-text">{{ loadingMessage }}</span>
    <!-- Tailwindcss loading component -->
    <div class="omni-spinner-border" role="status"></div>
  </div>
}
